// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lj-0";
export var assigneeDetails = "_lj-1";
export var assigneeInfo = "_lj-2";
export var dropdownContainer = "_lj-4";
export var dropdownImage = "_lj-5";
export var editAssigneeInfo = "_lj-3";
export var editAssigneeModalContainer = "_lj-6";
export var hidden = "_lj-8";
export var input = "_lj-7";